import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import futezapLogo from '../assets/futezap.jpg';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await api.post('/auth/login', values);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      message.success('Login realizado com sucesso!');
      onLogin(response.data.user);

      // Multi-time: se organizador tem >1 times em team_organizers, redireciona
      // pra tela de selecao. Senao, mantém redirect padrao.
      let redirectPath = response.data.user.profile === 'ORGANIZADOR' ? '/team-config' : '/dashboard';
      if (response.data.user.profile === 'ORGANIZADOR') {
        try {
          const t = await api.get('/organizer/teams/my');
          if ((t.data?.teams?.length || 0) > 1) {
            redirectPath = '/organizer/teams';
          }
        } catch { /* silencioso — fallback pro dashboard normal */ }
      }
      navigate(redirectPath);
    } catch (error) {
      if (error.response?.data?.needs_activation) {
        message.error('Conta não ativada. Redirecionando para ativação...');
        window.location.href = `/ativacao?customer_id=${error.response.data.customer_id}`;
      } else {
        message.error('Credenciais inválidas');
      }
    }
    setLoading(false);
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #00B96B 0%, #52C41A 100%)',
      padding: '16px'
    }}>
      <Card 
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'center' }}>
            <img src={futezapLogo} alt="Futezap" style={{ height: 40, width: 40, borderRadius: 4 }} />
            <span>Futezap</span>
          </div>
        } 
        style={{ 
          width: '100%', 
          maxWidth: 400, 
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)' 
        }}
      >
        <Form onFinish={onFinish} layout="vertical">
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Digite o número WhatsApp!' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="Número WhatsApp" 
              size="large"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Digite a senha!' }]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Senha" 
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              size="large"
              block
              style={{ background: '#00B96B', borderColor: '#00B96B' }}
            >
              Entrar
            </Button>
          </Form.Item>
          
          <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Button 
              type="link" 
              onClick={() => navigate('/forgot-password')}
              style={{ color: '#00B96B' }}
            >
              Esqueci minha senha
            </Button>
            
            <div style={{ color: '#666', fontSize: 14 }}>
              Ainda não tem cadastro?{' '}
              <Button 
                type="link" 
                onClick={() => navigate('/cadastro')}
                style={{ color: '#00B96B', padding: 0, fontSize: 14, fontWeight: 'bold' }}
              >
                Clique aqui e cadastre seu time
              </Button>
            </div>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;